import { Container } from "components/shared";
import styled from "styled-components";

export const NavMain = styled.nav`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 1rem 0;
    background: ${({ scrollY }) => (scrollY ? "var(--dark)" : "transparent")};
    z-index: 5;
`;

export const NavContainer = styled(Container)`
    height: 12vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Logo = styled.a`
    img {
        width: 4rem;
        height: auto;
    }
`;

export const List = styled.ul`
    display: flex;
`;

export const Item = styled.li`
    margin-left: 0.5rem;
`;
